/**
 * @generated SignedSource<<a1097e217aa9bdb5cf7dbd7e1e380e18>>
 * @relayHash 60b0b77d822f38b5be57cf41f9d126bb
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 60b0b77d822f38b5be57cf41f9d126bb

import { ConcreteRequest } from 'relay-runtime';
export type De_updateProgressNoteAnamnesisInput = {
  anamnesis: string;
  id: string;
};
export type deUpdateProgressNoteAnamnesisMutation$variables = {
  input: De_updateProgressNoteAnamnesisInput;
};
export type deUpdateProgressNoteAnamnesisMutation$data = {
  readonly de_updateProgressNoteAnamnesis: {
    readonly de_ProgressNoteMutationOutput: {
      readonly episodeOfCare: {
        readonly id: string;
        readonly updatedAt: string;
      } | null;
      readonly progressNote: {
        readonly anamnesis: string | null;
        readonly updatedAt: string;
      };
    } | null;
  };
};
export type deUpdateProgressNoteAnamnesisMutation = {
  response: deUpdateProgressNoteAnamnesisMutation$data;
  variables: deUpdateProgressNoteAnamnesisMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "de_EpisodeOfCare",
  "kind": "LinkedField",
  "name": "episodeOfCare",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anamnesis",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deUpdateProgressNoteAnamnesisMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_updateProgressNoteAnamnesisPayload",
        "kind": "LinkedField",
        "name": "de_updateProgressNoteAnamnesis",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_ProgressNoteMutationOutput",
            "kind": "LinkedField",
            "name": "de_ProgressNoteMutationOutput",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "de_ProgressNote",
                "kind": "LinkedField",
                "name": "progressNote",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deUpdateProgressNoteAnamnesisMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_updateProgressNoteAnamnesisPayload",
        "kind": "LinkedField",
        "name": "de_updateProgressNoteAnamnesis",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_ProgressNoteMutationOutput",
            "kind": "LinkedField",
            "name": "de_ProgressNoteMutationOutput",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "de_ProgressNote",
                "kind": "LinkedField",
                "name": "progressNote",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v3/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "60b0b77d822f38b5be57cf41f9d126bb",
    "metadata": {},
    "name": "deUpdateProgressNoteAnamnesisMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "9702a686c1f7d2cd38b9a81e4e493e4c";

export default node;
